export default __webpack_public_path__ + "static/google-qrcode-6ed5e6e4a41e9b6f3936c3e32bca03c0.png";